import React, { useContext } from "react";
import { EditReservationContext } from "./EditReservationContext";


export default function ReservationInstructorSearch() {
  const c = useContext(EditReservationContext);
  if (!c) return null;
  return (
    <div className="editReservationPopup__group-body">
       <div className="editReservationPopup__search-header">
          <input
             type="text"
             className="editReservationPopup__search-input"
             placeholder="Caută instructor "
             value={c.qInstructor}
             onChange={(e) => c.setQInstructor(e.target.value)}
          />
          <button
             className="editReservationPopup__btn editReservationPopup__btn--normal"
             onClick={() => c.setView("form")}
          >
             Înapoi
          </button>
       </div>

       <div className="editReservationPopup__search-list-wrapper">
          <ul className="editReservationPopup__search-list">
             {c.filteredInstructors.map((i) => {
                const full = `${i.firstName || ""} ${i.lastName || ""}`.trim();
                const phone = i.phone || "";
                return (
                   <li
                      key={i.id}
                      className="editReservationPopup__search-item"
                      onClick={() => {
                         c.setInstructorId(String(i.id));
                         c.setView("form");
                      }}
                   >
                      <h3>{c.highlightText(full, c.qInstructor)}</h3>
                      {phone && <p>{c.highlightText(phone, c.qInstructor)}</p>}
                   </li>
                );
             })}
          </ul>
       </div>
    </div>
  );
}
